import { DEFAULT_FILENAMES, IOS_DEVICE_NAME } from 'ts/constants/general';

import { getUserPlatform } from './getUserOs';

export const downloadByUrl = ({ url, filename }: { url: string; filename?: string }) => {
  const isIos = getUserPlatform() === IOS_DEVICE_NAME;

  if (isIos) {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    iframe.src = url;

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 2000);
  }

  const link = document?.createElement('a');

  link.href = url;
  link.setAttribute('target', '_blank');
  link.style.display = 'none';
  link.setAttribute('download', filename || DEFAULT_FILENAMES.DEFAULT);

  // Append to html link element page
  document.body.appendChild(link);

  // Start download
  link.click();

  // Clean up and remove the link
  link.parentNode?.removeChild(link);
};
